import Skill from './Skill';

export default Skill;
